// Llamadas a las funciones de IA del sistema.
//
// Van SIEMPRE con la sesión del usuario. Dos razones:
//   1. Sin sesión, cualquiera que conociera la URL del sistema podría gastar el
//      cupo de IA del corretaje desde afuera.
//   2. Es lo que le prueba al proxy de Corredata a QUÉ instancia pertenece la
//      llamada, sin tener que copiar ningún token en el Cloudflare del cliente
//      (ver functions/api/_claude.js).
import { supabase } from '../db/engine';

// Cabeceras con la sesión, para las llamadas de IA que arman su cuerpo a mano.
export async function authHeaders() {
  const { data: { session } } = await supabase.auth.getSession();
  return {
    'Content-Type': 'application/json',
    ...(session?.access_token ? { Authorization: `Bearer ${session.access_token}` } : {}),
  };
}

export async function postIA(ruta, cuerpo) {
  const { data: { session } } = await supabase.auth.getSession();
  const r = await fetch(ruta, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(session?.access_token ? { Authorization: `Bearer ${session.access_token}` } : {}),
    },
    body: JSON.stringify(cuerpo),
  });
  return await r.json().catch(() => ({}));
}
